import track from './track';

/**
 * Track the buttons clicks
 * @param {string} buttonText - button label
 */
export default function buttonClick({ buttonText }) {
    return track({
        event: 'buttonClick',
        buttonText,
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/button-click.js